import { Builder } from '@builder.io/sdk';
import { Icon, IconNames } from './Icon';
import { BuilderInputOptions } from '@/types/builder';

/*
  Helper function to create an enum field for icons. Adds a "None" option to the enum list.
 */
type IconEnumFieldParams = {
  name: string;
  required?: boolean;
  defaultValue?: string | null;
  helperText?: string;
  showIf?: (options: BuilderInputOptions) => boolean;
};

export const iconInput = ({ ...props }: IconEnumFieldParams) => {
  return {
    type: 'enum',
    enum: [{ label: 'None', value: '' }, ...IconNames.map((n) => ({ label: n, value: n }))],
    ...props,
  };
};

const IconConfig = {
  name: 'Icon',
  defaultStyles: {
    margin: '0',
  },
  inputs: [
    iconInput({
      name: 'name',
      required: true,
      defaultValue: IconNames[0],
    }),
  ],
};

Builder.registerComponent(Icon, IconConfig);
